import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@/globals.css";
import { msalInstance } from "@/lib/auth";
import { App } from "./App";

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element not found");
}

// Process the auth code from the redirect before rendering
msalInstance.initialize().then(() => {
  return msalInstance.handleRedirectPromise();
}).then(() => {
  createRoot(rootElement).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
});
